import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase/firebaseConfig";
import { Form, Input, Button, Typography, Card } from "antd";
import { MailOutlined, LockOutlined, LoginOutlined } from "@ant-design/icons";
import { useApp } from "../../context/AppContext";

const { Title } = Typography;

const Login = () => {
  const { message } = useApp();
  const [loading, setLoading] = useState(false);

  const onFinish = async ({ email, password }) => {
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      console.error("Login error:", err);
      let errorMessage = "";
      if (err.code === "auth/user-not-found" || err.code === "auth/invalid-credential") {
        errorMessage = "אימייל או סיסמה שגויים";
      } else if (err.code === "auth/user-disabled") {
        errorMessage = "המשתמש אינו מורשה להיכנס למערכת, נא פנה למנהל";
      } else {
        errorMessage = "שגיאה בהתחברות, נא פנה למנהל המערכת";
      }
      message.error(errorMessage);
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        direction: "rtl",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "linear-gradient(135deg, #e6f7ff 0%, #ffffff 100%)",
      }}
    >
      <Card
        style={{
          width: 350,
          textAlign: "center",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          borderRadius: 12,
          // position: "relative",
        }}
      >
        <img
          src="/logo.png"
          alt="logo_mashlimimplus"
          style={{ width: 150, margin: "12px auto", display: "block" }}
        />
        <Title level={3} style={{ marginBottom: 24 }}>
          התחברות למערכת
        </Title>

        <Form
          name="loginForm"
          layout="vertical"
          onFinish={onFinish}
          style={{ textAlign: "right" }}
        >
          <Form.Item
            label="אימייל"
            name="email"
            rules={[
              { required: true, message: "אנא הזן אימייל" },
              { type: "email", message: "האימייל שהוזן אינו תקין" },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="הקלד אימייל" />
          </Form.Item>

          <Form.Item
            label="סיסמה"
            name="password"
            rules={[{ required: true, message: "אנא הזן סיסמה" }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="הקלד סיסמה"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              icon={<LoginOutlined />}
              style={{
                borderRadius: 8,
                height: 40,
                fontWeight: "bold",
                fontSize: 16,
              }}
            >
              התחבר
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
